module.exports = __webpack_public_path__ + "img/super_privacy_01.83a1bb93.png";